/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Extract = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Extract"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="SVG">
      <path
        fill="#FFC220"
        d="M3.5 10.333C3.5 5.731 7.306 2 12 2s8.5 3.731 8.5 8.333v3.334c0 .92-.761 1.666-1.7 1.666s-1.7-.746-1.7-1.666S16.339 12 15.4 12s-1.7.746-1.7 1.667v6.666c0 .92-.761 1.667-1.7 1.667s-1.7-.746-1.7-1.667v-6.666c0-.92-.761-1.667-1.7-1.667s-1.7.746-1.7 1.667V17c0 .92-.761 1.667-1.7 1.667S3.5 17.92 3.5 17z"
        className="Main"
      />
      <path
        fill="#000"
        fillOpacity={0.5}
        fillRule="evenodd"
        d="M17.1 9.5a.84.84 0 0 1-.85-.833c0-1.381-1.142-2.5-2.55-2.5a.84.84 0 0 1-.85-.834c0-.46.38-.833.85-.833 2.347 0 4.25 1.865 4.25 4.167 0 .46-.38.833-.85.833"
        className="Details"
        clipRule="evenodd"
      />
    </g>
  </svg>
);

export const ExtractIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'extract-icon'}
      icon={Extract}
      {...props}
      size={size}
    />
  );
};
